exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".group-handle[data-v-7150c8a6]{display:flex;align-items:center}.group-handle__info[data-v-7150c8a6]{font-size:14px;font-weight:400;color:#000000;margin-right:12px}\n", ""]);

